import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

const ORIGIN =
  typeof window !== "undefined" ? window.location.origin : "";

/**
 * Per-page SEO: title, description, canonical, OG/Twitter, and JSON-LD schema list.
 */
export default function SEO({ title, description, path = "/", schemas = [], keywords }) {
  useEffect(() => {
    if (title) document.title = title;
    const url = `${ORIGIN}${path}`;

    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertLink("canonical", url);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    // JSON-LD
    const nodes = [];
    schemas.forEach((schema, i) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-schema", String(i));
      s.textContent = JSON.stringify(schema);
      document.head.appendChild(s);
      nodes.push(s);
    });

    return () => {
      nodes.forEach((n) => n.remove());
    };
  }, [title, description, path, keywords, schemas]);

  return null;
}
